var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"uk-margin-large-top"},[(_vm.$route.params.codeId)?_c('a',{staticClass:"uk-margin-small-right",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('vk-icon',{attrs:{"icon":"chevron-left","ratio":"2"}})],1):_vm._e(),_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89cc34ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = null
// module chunks = 